import { useLocalization } from "../../hooks/useLocalization";

interface RosterStatusBadgeProps {
  isActive: boolean;
}

export const RosterStatusBadge = ({ isActive }: RosterStatusBadgeProps) => {
  const { strings } = useLocalization();

  if (isActive) {
    return null;
  }

  return (
    <span className="inline-flex shrink-0 items-center rounded-full bg-[rgba(148,163,184,0.16)] px-[0.4rem] py-[0.12rem] text-[0.65rem] font-bold uppercase tracking-[0.05em] text-[#94a3b8]">
      {strings.LEADERBOARD.SUB_BADGE}
    </span>
  );
};
